import { loggedIn, virtualDir } from "#skyward_global";
import { registerLoadDOMCallback } from "#skyward_window";
import { JQueryInput } from "./types";

const classNames =
{
    container: "skywardSizedContainer",
    xsmall: "skywardSizedContainer--XS",
    small: "skywardSizedContainer--S",
    medium: "skywardSizedContainer--M",
    large: "skywardSizedContainer--L",
    xlarge: "skywardSizedContainer--XL",
    xxlarge: "skywardSizedContainer--XXL",
};
export function getClosestSizedContainer(selector: JQueryInput)
{
    const element = $(selector);
    if (element.length === 0)
    {
        return $(`body.${classNames.container}`);
    }

    return element.closest(`.${classNames.container}`);
}

function init(selector: JQueryInput)
{
    let html = $(selector);
    // The ModalLayer framework triggers the NotifyDOMLoad event on the body of the modal, not the container.
    if (html.is(".messageBox.modal.content"))
    {
        html = html.closest(".modalLayerContainer");
    }
    const bodySizedContainer = html.find(`body.${classNames.container}`);
    const sizedContainers = html.find(`.${classNames.container}`);

    const containerResizeObserver = new ResizeObserver(handleContainerEntries);
    const bodyResizeObserver = new ResizeObserver(handleBodyEntries);

    sizedContainers.each(function ()
    {
        const element = $(this);
        if (!element.data().skywardSizedContainerWidth)
        {
            containerResizeObserver.observe(this);
        }
    });

    if (bodySizedContainer.length > 0)
    {
        bodyResizeObserver.observe(bodySizedContainer[0]);
    }
}

function getSizeCode(width: number)
{
    switch (true)
    {
        case width >= 2560:
            return "XXL";
        case width >= 1920:
            return "XL";
        case width >= 1280:
            return "L";
        case width >= 640:
            return "M";
        case width >= 480:
            return "S";
        default:
            return "XS";
    }
}

async function handleBodyEntries(entries: ResizeObserverEntry[])
{
    for (const entry of entries)
    {
        const target = $(entry.target);
        if (target.length === 0)
        {
            continue;
        }
        const previousSizeCode = target.data("window-size-code");
        const width = entry.contentRect.width;
        const currentSizeCode = getSizeCode(width);

        if (previousSizeCode !== currentSizeCode)
        {
            try
            {
                const changeEvent = new CustomEvent('sizedContainer:change',
                {
                    bubbles: false,
                    detail: { oldSize: previousSizeCode, newSize: currentSizeCode }
                });

                const element = target[0];
                element.dispatchEvent(changeEvent);

                target.data("window-size-code", currentSizeCode);

                if (!loggedIn)
                {
                    return;
                }

                await $.ajax(`${virtualDir}Security/Window/UpdateWindowSize`,
                    {
                        type: "POST",
                        dataType: "JSON",
                        data: { sizeCode: currentSizeCode }
                    });
            }
            catch (error)
            {
                console.error("Failed to update window size code:", error);
            }
        }
    }
}

function handleContainerEntries(entries: ResizeObserverEntry[])
{
    for (const entry of entries)
    {
        const width = entry.contentRect.width;
        const target = $(entry.target);
        target.data("skyward-sized-container-width", width);
        target.toggleClass(classNames.xsmall, true);
        target.toggleClass(classNames.small, width >= 480);
        target.toggleClass(classNames.medium, width >= 640);
        target.toggleClass(classNames.large, width >= 1280);
        target.toggleClass(classNames.xlarge, width >= 1920);
        target.toggleClass(classNames.xxlarge, width >= 2560);
    }
}

registerLoadDOMCallback(init, 1);